var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#EB0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0279 12.2344H8.8859L8.4359 3.64844H11.4779L11.0279 12.2344ZM8.3999 15.2404C8.3999 14.6884 8.5499 14.3044 8.8499 14.0884C9.1499 13.8604 9.5159 13.7464 9.9479 13.7464C10.3679 13.7464 10.7279 13.8604 11.0279 14.0884C11.3279 14.3044 11.4779 14.6884 11.4779 15.2404C11.4779 15.7684 11.3279 16.1524 11.0279 16.3924C10.7279 16.6204 10.3679 16.7344 9.9479 16.7344C9.5159 16.7344 9.1499 16.6204 8.8499 16.3924C8.5499 16.1524 8.3999 15.7684 8.3999 15.2404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.0377ac968b085d2b6c85fb0bccc8d824.svg";
export { ForwardRef as ReactComponent };